import React, { useState } from "react";

function ZonaSelector({ from, handleZone }) {
  const zonasPredefinidas = [
    "Zona Norte",
    "Zona Noreste",
    "Zona Este",
    "Zona Sureste",
    "Zona Sur",
    "Zona Suroeste",
    "Zona Oeste",
    "Zona Noroeste",
    "Zona Centro"
  ];
  const [zonasSeleccionadas, setZonasSeleccionadas] = useState([]);

  const addZona = (zona) => {
    if (!zonasSeleccionadas.includes(zona)) {
      setZonasSeleccionadas([...zonasSeleccionadas, zona]);
      handleZone([...zonasSeleccionadas, zona]);
    }
  };

  const removeZona = (zona) => {
    setZonasSeleccionadas(
      zonasSeleccionadas.filter((z) => z !== zona)
    );
    handleZone(
      zonasSeleccionadas.filter((z) => z !== zona)
    );
  };

  return (
    <section className="p-4 bg-gray-100 rounded shadow-md max-w-md mx-auto">
      {from?'':
      <h2 className="text-lg font-semibold mb-4">Seleccionar tus Zonas de Trabajo</h2>
      }
      
      {/* Select */}
      <div className="relative mb-4">
        <select
          className="w-full p-2 border rounded focus:outline-none focus:ring focus:ring-blue-300"
          onChange={(e) => addZona(e.target.value)}
        >
          <option value="">Seleccione una zona</option>
          {zonasPredefinidas.map((zona) => (
            <option key={zona} value={zona}>
              {zona}
            </option>
          ))}
        </select>
      </div>

      {/* Chips */}
      <div className="flex flex-wrap gap-2">
        {zonasSeleccionadas.map((zona) => (
          <div
            key={zona}
            className="flex items-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full shadow"
          >
            <span>{zona}</span>
            <button
              className="ml-2 text-blue-500 hover:text-blue-700"
              onClick={() => removeZona(zona)}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ZonaSelector;
